module.exports = __webpack_public_path__ + "static/media/ionic.711aa5b5.svg";